<template>
  <v-container id="contact-list" class="contact-list" fluid tag="section" style="margin-top: -15px">
    <div class="md-layout">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <v-expansion-panels
        v-model="viewExpansionPanels"
        multiple
      >
        <v-expansion-panel>
          <v-expansion-panel-content class="panel-no-pb contact-filter">
            <v-row :style="isMobile ? 'height: 160px' : 'height: 50px'">
              <v-col cols="12" md="4" class="pb-0 pt-0">
                <div class="text-left mb-1 mt-2">
                  <v-menu offset-y v-if="checkAuthorization('reconcile-sms_view_all')">
                    <template #activator="{ on: onMenu }">
                      <v-tooltip bottom>
                        <template #activator="{ on: onTooltip }">
                          <v-btn
                            min-width="45"
                            style="margin-right: 10px;"
                            class="mb-2"
                            color="info"
                            small
                            v-on="{ ...onMenu, ...onTooltip }"
                          >
                            <v-icon>mdi-gesture-tap</v-icon>
                          </v-btn>
                        </template>

                        <span>Thao tác</span>
                      </v-tooltip>
                    </template>
                    <v-list>
                     <template v-for="(action, index) in actionList">
                         <v-list-item
                                 :key="`${action.id}_${index}`"
                                 @click="showModalAction(action.type, action.store)"
                                 v-if="checkAuth(action.role)">
                             <v-list-item-title>
                                 {{ action.title }}
                             </v-list-item-title>
                         </v-list-item>
                     </template>
                    </v-list>
                  </v-menu>

                  <template v-if="false">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          min-width="45"
                          v-on="on"
                          small
                          style="margin-right: 10px;"
                          color="primary"
                          dark
                          class="mb-2"
                          @click="clickAddContact"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Thêm mới</span>
                    </v-tooltip>
                  </template>

                  <v-tooltip bottom v-if="false">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        min-width="45"
                        v-on="on"
                        small
                        @click="chooseFile"
                        style="margin-right: 10px;"
                        color="success"
                        dark
                        class="mb-2"
                      >
                        <v-icon style="margin-right: 5px;">mdi-folder-upload</v-icon>
                      </v-btn>
                    </template>
                    <span>Upload</span>
                  </v-tooltip>

                  <v-menu
                    v-if="false"
                    :internal-activator="true"
                    v-model="filterForm.openRowMenu"
                    content-class="menu__customer--filter no-contain overflow-visible"
                    :close-on-content-click="false"
                    offset-y
                  >
                    <template #activator="{ on: onMenu }">
                      <v-tooltip bottom>
                        <template #activator="{ on: onTooltip }">
                          <v-btn
                            min-width="45"
                            small
                            class="mb-2"
                            dark
                            v-on="{ ...onMenu, ...onTooltip }"
                          >
                            <v-icon>mdi-view-column</v-icon>
                          </v-btn>
                        </template>

                        <span>Cột hiển thị</span>
                      </v-tooltip>
                    </template>
                    <card-row-attribute
                      :filterForm="filterForm"
                      :contactColumns="contactColumns"
                      :rowAttributes="rowAttributes"
                    />
                  </v-menu>

                  <v-tooltip bottom v-if="false">
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                        min-width="45"
                        @click="showStatusTable()"
                        small
                        color="warning"
                        class="mb-2 ml-2"
                        dark
                        v-on="onTooltip"
                      >
                        <v-icon>mdi-format-align-middle</v-icon>
                      </v-btn>
                    </template>

                    <span>Ẩn/hiện mối quan hệ</span>
                  </v-tooltip>

                  <template v-if="false">
                    <v-menu offset-y>
                      <template #activator="{ on: onMenu }">
                        <v-tooltip bottom>
                          <template #activator="{ on: onTooltip }">
                            <v-btn
                              min-width="45"
                              class="ml-2 mb-2"
                              color="secondary"
                              dark
                              v-on="{ ...onMenu, ...onTooltip }"
                              small
                            >
                              <v-icon>mdi-format-align-bottom</v-icon>
                            </v-btn>
                          </template>

                          <span>Số dòng hiển thị</span>
                        </v-tooltip>
                      </template>
                      <v-list class="s-lines-displayed" style="min-width: 100px">
                        <v-list-item
                          class="lines-displayed pa-0"
                          style="cursor: pointer"
                          v-for="(item, index) in items"
                          :key="`${item.id}_${index}`"
                        >
                          <v-list-item-title
                            class="item-lines-displayed"
                            @click="changeLimit(item)"
                          >{{ item }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>

                  <v-tooltip bottom v-if="false">
                    <template #activator="{ on: onTooltip }">
                      <v-btn
                          min-width="45"
                          @click="showModule"
                          small
                          color="#096860"
                          class="mb-2 ml-2"
                          dark
                          v-on="onTooltip"
                      >
                        <v-icon>mdi-view-compact</v-icon>
                      </v-btn>
                    </template>

                    <span>Ẩn/hiện kho tổng</span>
                  </v-tooltip>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="pb-0 pt-0"
                  :style="isMobile ? 'height: 35px' : ''">
                <filter-form
                  :filter-form="filterForm"
                  :banks="banks"
                />
              </v-col>
              <!-- <v-col cols="12" md="1"></v-col> -->
              <!-- <v-col cols="12" md="3" class="pb-0" v-if="totalItem > limit" style="display: flex; justify-content: flex-end"> -->

              <v-col :cols="isMobile ? 8 : 12" md="3" class="pb-0"
                  style="display: flex; justify-content: flex-end; padding: 0 12px">
                <div class="text-right mb-1 mt-2">
                  {{showContactsIndex()}}
                  <v-btn
                      small
                      class="pagination-btn-left"
                      @click="function() {currentPage--; pendingPage--}"
                      :disabled="currentPage == 1">
                    <v-icon>mdi-menu-left</v-icon>
                  </v-btn>
                  <v-btn
                      small
                      class="pagination-btn-right"
                      @click="function() {currentPage++; pendingPage++}">
                    <v-icon>mdi-menu-right</v-icon>
                  </v-btn>
                </div>
                <div style="width: 35px">
                  <v-text-field
                    class="pt-0"
                    v-model="pendingPage"
                    min="1"
                    step="1"
                    type="number"
                    @input="applyPendingPage()">
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-show="showStatus" transition="fade" class="contact-status-table">
            <v-row>
              <v-col cols="12" class="pt-0 pb-0">
                <status-count-table
                  :filterForm="filterForm"
                  :totalContactStatus="totalContactStatus"
                  :typeHeaderContactStatus="typeHeaderContactStatus"
                  :contactStatusList="countContactStatusList"
                  :styleCountStatus="styleCountStatus"
                />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
          <v-expansion-panel-content class="s-table-contact">
            <div>
              <contact-table
                :rowAttributes="rowAttributes"
                :filter-form="filterForm"
                :contacts="contacts"
                :currentPage="currentPage"
                :limit="parseInt(limit)"
                :mapStatusCode="mapStatusCode"
              />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
<!--    <modal-change-status-->
<!--      v-if="filterForm.modalType === 'status'"-->
<!--      :filter-form="filterForm"-->
<!--      :contacts="contacts"-->
<!--      :contactsSelected="contactsSelected"-->
<!--    />-->
      <modal-import-file
              :is-popup-import="isPopupImport"
              @closeModal="closeModalImport"
              @choose-file="handleChooseUploadFile"
      />
    <div v-if="isPopupNote">
      <modal-approved
          :isOpenPopupApprove="isPopupNote"
          :titlePopup="'Ghi chú'"
          :placeholderPopup="'Nhập ghi chú'"
          :contactChoose="transactionChoose"
          @confirmApproved="checkApprovedFeedbackNote"
          @closeModal="closeModalApproveNote"
      />
    </div>
  </v-container>
</template>

<script>
import FilterForm from './components/FilterForm';
import StatusCountTable from './components/StatusCountTable';
import ContactTable from './components/Table';
import { getContactAttribute } from './config';
import RepositoryFactory from '@/repositories/RepositoryFactory'
const OrderRepository = RepositoryFactory.get('order')
const ContactStatusRepository = RepositoryFactory.get('contact_status');
import {
  contactStatus,
  typeContactExpand,
  contactStatusDefaultColor
} from '@/helpers/constants';
import { checkMobile } from '@/helpers/utils'
const ContactRepository = RepositoryFactory.get('contact');
const STATUS_TOKEN_EXPIRED = 402;
import CardRowAttribute from './components/CardRowAttribute';
import { DA_XU_LY } from "@/helpers/constants";
import moment from 'moment'
import ModalApproved from "@/pages/order-payment-checklist/components/ModalApproved";
import ModalImportFile from "@/pages/order-payment-checklist/components/ModalImportFile.vue";
export default {
  components: {
      ModalImportFile,
    ContactTable,
    StatusCountTable,
    FilterForm,
    CardRowAttribute,
    ModalApproved,
  },
  data() {
    return {
      errorMessage: '',
      items: [10, 20, 50, 100, 200, 500],
      filterForm: {
        closeMenu: false,
        keyword: '',
        transactionStatus:'',
        bankName:'',
        transferMethod:'',
        transferDate:[],
        statusIds:'',
        approvedBy: '',
        importingSource: '',
      },
      currentPage: 1,
      pendingPage: 1,
      limit: 50,
      contacts: [],
      loading: true,
      viewExpansionPanels: [0, 1],
      panel: [0, 1],
      typeHeaderContactStatus: [],
      countContactStatusList: [],
      totalContactStatus: 0,
      banks:[],
      showStatus: true,
      contactColumns: {},
      rowAttributes: getContactAttribute(),
      isMobile: false,
      productList: [],
      listStudyResult: {
        CHAMCHI: 'Chăm chỉ',
        BINHTHUONG: 'Bình thường',
        LUOIHOC: 'Bình thường',
        KHONGHOC: 'Không học',
        PHUCTAP: 'Phức tạp'
      },
      provinceList: [],
      contactsSelected: [],
      typeHeaderContactModule: [],
      countContactModuleList: [],
      totalContactModule: 0,
      showModuleTable: true,
      isShowModule: false,
      mapContactStatusIdCanCall: {},
      styleCountStatus: 2,
      mapStatusCode: {},
      isPopupNote: false,
      isPopupImport: false,
      isClosePopupImport: false,
      transactionChoose: {
        ids: null,
        comment: '',
      },
    };
  },
  computed: {
    actionList() {
      const actionList = [];
      actionList.push(
          { title: 'Chuyển đã xử lý', type: 'change-status-to-processed', store: 'all', role: '' },
          { title: 'Import từ sao kê', type: 'change-import-xlsx', store: 'all', role: 'import-statement_read' }

      );

      return actionList;
    },
    statusContactViewAll() {
      return this.checkAuthorization('contact_view_all');
    }
  },
  async created() {
    if (!_.isEmpty(this.$route.query)) {
      for (let key in this.$route.query) {
        this.filterForm[key] = this.$route.query[key]
      }
    }

    if (this.filterForm.store == 'G') {
      if (!this.checkAuthorization('check_store_g_read')) {
        this.filterForm.store = 'T'
        window.history.pushState({store: 'T'}, "",
          window.location.origin + "/contact/contact-list?store=T")
      }
    }

      this.showStatus = true
      this.showModuleTable = true
      this.isShowModule = true
    await this.getListBanks();
    this.getList();
    this.getCountStatusList();

    let check = checkMobile()
    if (check) {
      this.isMobile = true
    }
    setTimeout(() => {
      Bus.$on('contact-list-filter', filterForm => {
        this.filterForm = filterForm;
        this.filterForm.closeMenu = false;
        if(this.currentPage != 1){
          this.currentPage = 1;
          this.pendingPage = 1;
        }else if(this.currentPage == 1) {
          this.getList();
          this.getCountStatusList();
        }
      });
      Bus.$on('contact-list-filter-by-contact-status', filterForm => {
        this.filterForm = filterForm;
        this.filterForm.closeMenu = false;
        if(this.currentPage != 1){
          this.currentPage = 1;
          this.pendingPage = 1;
        }else if(this.currentPage == 1) {
          this.getList();
        }
      });
      Bus.$on('product-group-list', () => {
        this.getList()
      });
      Bus.$on('contact-change-row-attribute', cloneRowAttributes => {
        this.rowAttributes = cloneRowAttributes.map(s => ({ ...s }));
      });
    }, 0);
  },
  async updated() {
    setTimeout(() => {
      this.getStyleTable();
    }, 300);
  },
  beforeDestroy() {
    Bus.$off('contact-list-filter');
    Bus.$off('contact-change-row-attribute');
    Bus.$off('contact-list-filter-by-contact-status');
    Bus.$off('product-group-list');
  },
  methods: {
      checkAuth(role) {
        if(role) {
            return this.checkAuthorization(role)
        }
        return true
      },
      closeModalImport() {
          this.isPopupImport = false
      },
     async handleChooseUploadFile(data) {
          this.appLoadingData(true)
          if (data) {
              const uploadResponse = await ContactRepository.uploadImportFileSMS(data);
              this.appLoadingData(false)
              if (_.get(uploadResponse, 'success', false)) {
                  this.$swal({
                      title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
                  });
                  this.closeModalImport()
              } else {
                  this.$swal({
                      icon: 'error',
                      type: 'error',
                      title: 'Tải lên thất bại',
                      text: _.get(uploadResponse, 'message', '')
                  });
              }
          }
      },
    getStyleTable() {
      let heightFilter = document.querySelector('.contact-filter')
        ? document.querySelector('.contact-filter').clientHeight
        : 0;
      let heightReport = document.querySelector('.report-achievement')
        ? document.querySelector('.report-achievement').clientHeight
        : 0;
      let heightStatus = document.querySelector('.contact-status-table')
        ? document.querySelector('.contact-status-table').clientHeight
        : 0;
      let totalHeader =
        heightFilter + heightReport + heightStatus + 45 + 'px';
      let heightTable = document.querySelector('.contact-table');
      if(heightTable) {
        if (this.contacts.length === 0) {
          heightTable.style.height = `auto`;
        } else {
          heightTable.style.height = `calc(100vh - ${totalHeader})`;
        }
      }
    },
    chooseFile() {
      this.$refs.contactFileInput.click();
    },
    async changeLimit(limit) {
      this.limit = limit;
    },
    showStatusTable() {
      this.showStatus = !this.showStatus;
      if(this.isShowModule && this.showModuleTable) {
        this.showModuleTable = false
      }
      if(this.showStatus && _.isEmpty(this.typeHeaderContactStatus)) {
        //this.getCountStatusList();
      }
    },
    showPopup() {
      this.$swal({
        title: 'Upload data',
        text: 'Bạn có thực sự chắc chắn ?',
        confirmButtonText: 'Đồng ý',
        showCancelButton: true,
        cancelButtonText: 'Hủy bỏ'
      }).then(async (res) => {
        if(res.value) {
          await this.onSelectContactFile();
        }
        else{
          this.$refs.contactFileInput.value = '';
        }
      })
    },
    async onSelectContactFile() {
      // const loader = this.$loading.show();
      this.appLoadingData(true)
      const input = this.$refs.contactFileInput;
      const files = input.files;
      if (files && files[0]) {
        const contactFile = files[0];
        const uploadResponse = await ContactRepository.uploadContact(
          contactFile,
          _.get(this.filterForm, 'store', 'T')
        );
        this.appLoadingData(false)
        // loader.hide();
        this.$refs.contactFileInput.value = '';
        if (_.get(uploadResponse, 'success', false)) {
          this.$swal({
            title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
          });
        } else {
          this.$swal({
            type: 'error',
            title: 'Thông báo !',
            text: _.get(uploadResponse, 'message', '')
          });
        }
      }
    },
    openNoteChangeStatus() {
      this.isPopupNote = true;
    },
    closeModalApproveNote() {
      this.isPopupNote = false;
      this.transactionChoose = {
        ids: null,
        comment: '',
      };
    },
    async checkApprovedFeedbackNote(){
          const body = {
            statusId: DA_XU_LY,
            transactionId: this.transactionChoose.ids,
            approvedFeedback: this.transactionChoose.comment,
          }
          const res = await OrderRepository.changeTransactionStatus(body)
          if(res?.success){
            this.$swal({
              type: 'success',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false,
              title: 'Thao tác thành công !!!',
            })
            this.getList();
            this.getCountStatusList();
            this.closeModalApproveNote();
          }else{
            this.$swal({
              type: 'error',
              title: 'Thông báo !',
              text: res?.errors?.showMessage ?? 'Thao tác không thành công !!!'
            });
          }
    },
    showModalAction(modalType, store = 'all') {
      if (modalType === 'change-status-to-processed') {
          const changeContactList = this.contacts.filter(
              contact => contact.checkbox
          );
          const transactionSelectedIds = changeContactList.map(e => e.id)
          this.contactsSelected = _.cloneDeep(changeContactList)
          if (changeContactList.length === 0) {
              return this.$swal({
                  title: 'Thông báo!',
                  text: 'Chưa có giao dịch nào được chọn !!!'
              });
          }
        this.transactionChoose.ids = transactionSelectedIds
        this.openNoteChangeStatus()
      }else if(modalType === 'change-import-xlsx') {
          this.isPopupImport = true
      }
      this.filterForm.modalType = modalType;
    },
    async revokeContacts(changeContactList, store) {
      let statusId = 0
      if (store == 'C') {
        statusId = contactStatus.CO
      } else if (store == 'T') {
        statusId = contactStatus.T0
      } else if (store == 'G') {
        statusId = contactStatus.G0
      } else if (store == 'M') {
        statusId = contactStatus.M0
      }
      const dataUpdate = changeContactList.map(contact => ({
        contactId: contact.id,
        statusId,
      }));
      // this.loading = this.$loading.show();
      this.appLoadingData(true)
      const response = await ContactRepository.updateContactStatus(dataUpdate);
      // this.loading.hide();
      this.appLoadingData(false)
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      }
      this.getList();
      //this.getCountStatusList();
    },
    async deleteContacts(changeContactList) {
      return this.$swal({
        title: 'Bạn muốn xoá các contacts này',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        closeOnConfirm: false,
        cancelButtonText: 'Huỷ Bỏ'
      }).then(async result => {
        if (!result.value) {
          return;
        }
        const dataUpdate = changeContactList.map(contact => contact.id);
        // this.loading = this.$loading.show();
        this.appLoadingData(true)
        const response = await ContactRepository.deleteContacts(dataUpdate);
        let contactDeleteErrors = _.get(response, 'data', []).filter(ele => ele.error)
        // this.loading.hide();
        this.appLoadingData(false)
        if (contactDeleteErrors.length) {
          this.$swal({
            type: 'error',
            title: 'Lỗi !',
            text: _.get(contactDeleteErrors[0], 'message', '')
          });
          return;
        }
        this.$swal({
          title: 'Xoá các contact thành công !!!',
          confirmButtonText: 'Đồng ý'
        }).then(() => {
          this.getList();
          //this.getCountStatusList();
        });
      });
    },
    clickAddContact() {
      alert('add-contact');
    },
    async getCountStatusList() {
      if (!this.showStatus) {
        this.typeHeaderContactStatus = []
        return
      }

      let filterForm = _.cloneDeep(this.filterForm)
      const params = {
        keyword: this.filterForm.keyword?.trim(),
        transferMethod: this.filterForm.transferMethod,
        //transactionStatus: this.filterForm.transactionStatus,
        bankName: this.filterForm.bankName,
        approvedBy: this.filterForm.approvedBy,
        importingSource : this.filterForm.importingSource
      };
      if(this.filterForm.transferDate?.length > 0){
        params.transferDate = `${moment(this.filterForm.transferDate[0]).format("YYYY/MM/DD HH:mm:ss")}-${moment(this.filterForm.transferDate[1]).format("YYYY/MM/DD HH:mm:ss")}`
      }

      if (!this.filterForm.monthPicker && !this.filterForm.inputPointCumulated){
        delete params.cumulativePointMonthYear
      }
      const [response, responseContactStatus] = await Promise.all([
        OrderRepository.getListCountStatusOrderPaymentCheckout(params),
        ContactStatusRepository.contactStatusAddon(),
      ]);
      const statusIds = responseContactStatus.data?.map(s => s.contactStatusId);
      this.mapContactStatusIdCanCall = statusIds.reduce((acc, num) => {
        acc[num] = true;
        return acc;
      }, {});
      if(this.styleCountStatus === 1){
        this.totalContactStatus = 0;
        if (response.success) {
          const typeHeaderContactStatus = [];
          const contactStatusList = [];
          const typeExpand = typeContactExpand;
          let statusFirstTypeExpand = false;
          let notInTypeList = [];
          if (!this.isManager()) {
            notInTypeList = ['T0', 'C0', 'G0'];
          }
          for (let contactStatus of _.get(response, 'data', [])) {
            if (notInTypeList.includes(contactStatus.type)) {
              continue;
            }
            typeHeaderContactStatus.push({
              name: !this.$store.state.module.typeId ? contactStatus.type : contactStatus.type.slice(-2),
              colspan: _.get(contactStatus, 'data', []).length || 1
            });
            _.get(contactStatus, 'data', []).forEach(data => {
              contactStatusList.push({
                type: contactStatus.type,
                id: _.get(data, 'id', 0),
                color:
                    _.get(data, 'color', contactStatusDefaultColor) ||
                    contactStatusDefaultColor,
                noContact: _.get(data, 'noContact', 0),
                name: _.get(data, 'name', 0),
                statusFirstTypeExpand:
                    typeExpand.includes(contactStatus.type) &&
                    !statusFirstTypeExpand
              });
              if (
                  typeExpand.includes(contactStatus.type) &&
                  !statusFirstTypeExpand
              ) {
                statusFirstTypeExpand = true;
              }

              this.totalContactStatus += parseInt(_.get(data, 'noContact', 0));
            });
          }
          this.typeHeaderContactStatus = typeHeaderContactStatus;
          this.countContactStatusList = contactStatusList;
        } else {
          const statusCode = _.get(response, 'data.code', 200);
          this.typeHeaderContactStatus = [];
          this.countContactStatusList = [];
          this.totalContactStatus = 0;
        }
      }
      if(this.styleCountStatus === 2){
        const countStatusModuleList = [];
        let totalContact = 0;
        if (response.success && !response.data.length) {
          countStatusModuleList.push({
            type: item.name, id: 0, noContact: '', name: '', typeId: item.id, color: '#ffffff',
          });
        }
        response.data.forEach((item) => {
          if (item.code !== 'all') {
            this.mapStatusCode[item.code] = { color: item.color ,name: item.name };
            totalContact += parseInt(item.no, 10);
            const bodyObject = {
              id: item.id, noContact: item.no, name: item.name, color: item.color,
            };
            countStatusModuleList.push(bodyObject);
          }
        });
        this.countContactStatusList = countStatusModuleList;
        this.totalContactStatus = totalContact;
      }
    },
    async getListBanks(){
      const response = await OrderRepository.getListBanks();
      if (response?.success){
        this.banks = _.get(response, 'data', []);
      }
    },
    async getList() {
      const loading = this.$loading.show()
      const params = {
        limit: this.limit,
        page: this.currentPage - 1,
        keyword: this.filterForm.keyword?.trim(),
        transferMethod: this.filterForm.transferMethod,
        transactionStatus: this.filterForm.transactionStatus,
        bankName: this.filterForm.bankName,
        approvedBy: this.filterForm.approvedBy,
        importingSource: this.filterForm.importingSource
      };
      if(this.filterForm.transferDate?.length > 0){
        params.transferDate = `${moment(this.filterForm.transferDate[0]).format("YYYY/MM/DD HH:mm:ss")}-${moment(this.filterForm.transferDate[1]).format("YYYY/MM/DD HH:mm:ss")}`
      }
      if (!this.filterForm.monthPicker && !this.filterForm.inputPointCumulated){
        delete params.cumulativePointMonthYear
      }

      this.filterForm.modalType = '';
      this.filterForm.checkboxAll = false;
      const response = await OrderRepository.getListOrderPaymentCheckout(params)
      loading.hide();
      if (response.success) {
        let data = _.get(response, 'data', []);
        data.forEach(record => {
          record.checkbox = false;
        })
        this.contacts = data
      } else {
        this.contacts = [];
        const statusCode = _.get(response, 'data.code', STATUS_TOKEN_EXPIRED);
      }
    },
    applyPendingPage: _.debounce(function() {
        this.currentPage = parseInt(this.pendingPage)
        return
    }, 500),

    showContactsIndex() {
      if(this.contacts.length > 0) {
        let maxIndex = parseInt(this.currentPage)*parseInt(this.limit)
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
      }else {
        return ('0 - 0')
      }
    },
    showModule() {
      this.showModuleTable = !this.showModuleTable;
      if(this.showStatus) {
        this.showStatus = false;
      }
    }
  },
  watch: {
    currentPage: {
      handler() {
        this.getList();
      }
    },
    filterForm: {
      handler(val) {
        if(val?.keyword?.length > 30){
          this.$swal({
            title: 'Ký tự tìm kiếm không được vượt quá 30 ký tự',
          })
        }
      },
      deep: true,
    },
    limit: {
      handler() {
        if (this.currentPage === 1) {
          this.getList();
        } else {
          this.currentPage = 1;
          this.pendingPage = 1;
        }
      }
    }
  }
};
</script>
<style scoped>
#contact-list {
  padding-bottom: 0px;
}
/deep/.v-expansion-panel::before {
  box-shadow: none;
}
/deep/.c-pagination .v-pagination__navigation {
  height: 28px;
  width: 28px;
}
/deep/.c-pagination .v-pagination__item {
  height: 28px;
  min-width: 28px;
  font-size: 12px;
}
.lines-displayed {
  min-height: auto;
}
.lines-displayed .item-lines-displayed {
  width: 100%;
  padding: 8px 15px;
  margin: 4px 0px;
  cursor: pointer;
}
.lines-displayed .item-lines-displayed:hover {
  background: #d2d2d2;
}
/deep/.filter-store input {
  font-size: 13px !important;
}
/deep/.report-achievement .v-expansion-panel-content__wrap {
  padding: 0;
}

.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}
.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}
.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}
.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
/deep/.panel-no-pb .v-expansion-panel-content__wrap {
  padding-bottom: 0px;
}
/deep/.v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding-left: 15px;
  padding-right: 15px;
}
/deep/.s-table-contact.v-expansion-panel-content .v-expansion-panel-content__wrap {
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 0px;
}
</style>
